package com.ives.modules.mip;

import com.ives.modules.adjustments.Adjustments;
import com.ives.modules.vrc.ReconstructionSettings;
import com.ives.components.workspace.DicomWorkspace;
import com.ives.components.viewer.DicomViewer;
import com.ives.utils.Config;
import com.ives.modules.ModuleEvent;

class MIP extends RayCastingClient{
	static private inline var MIP_MODULE:String = "MIP_MODULE";
	static private inline var MIP_WORKSPACE:String = "MIP_WORKSPACE";
	static private inline var MIP_EVENT:String = "MIP_EVENT";

	public function new(){
		settingSteps = [
			new ReconstructionSettings(256, 256, 10),
			new ReconstructionSettings(256, 256, 5),
			new ReconstructionSettings(256, 256, 1)
		];
	}

	override public function init(dicomViewer:DicomViewer, ?dicomWorkspace:DicomWorkspace){
		superInit(dicomViewer, dicomWorkspace);

		if(getWorkspaceMode() != MIP_WORKSPACE)
			return;
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == MIP_MODULE && getWorkspaceMode() != MIP_WORKSPACE)
			dispatchEvent(new ModuleEvent(DicomViewer.LAYOUT_CHANGE, [1, 1], [MIP_WORKSPACE]));

		if(event.type == MIP_EVENT && getWorkspaceMode() == MIP_WORKSPACE)
			handleEvent(event);

		if(event.type == Adjustments.ADJUSTMENTS_WINDOW && getWorkspaceMode() == MIP_WORKSPACE)
			start();

		if(event.type == DicomWorkspace.WORKSPACE_READY && getWorkspaceMode() == MIP_WORKSPACE)
			super.init(dicomViewer, dicomWorkspace);
	}

	override private function setUrl(settings:ReconstructionSettings){
		dicomWorkspace.dicomImage.setBaseUrl('${Config.SERVER_URL}/dicom/${dicomViewer.originalDicomImageData.sourceName}/context/${dicomViewer.originalDicomImageData.id}/mip?rotation=${rotation}&screen=${screen}&distance=${cameraDistance}&fov=${fov}&spacing=${pixelSpacing}&step=${settings.step}');
	}

	override private function updateCamera(data:Array<Float>){
		dispatchEvent(new ModuleEvent(MIP_EVENT, data, false, true));
	}
}
